<script setup lang="ts">
defineProps({
  needBg: { type: Boolean },
  className: null
})
const emits = defineEmits(['shareHandle'])
const shareHandle = () => {
  emits('shareHandle')
}
</script>

<template>
  <div
    v-if="needBg"
    class="cursor-pointer rounded-1/2 w-9 h-9 flex items-center justify-center sm:hover:bg-white sm:hover:bg-op-6 active:bg-white active:bg-op-6"
    @click="shareHandle"
  >
    <div i-uil:share class="icon text-5" />
  </div>
  <div v-else class="flex items-center justify-center icon-box">
    <div i-uil:share class="cursor-pointer text-5" :class="className || 'icon'" @click="shareHandle" />
  </div>
</template>
